import React from "react";
import MarketsFilter from "../../components/marketsFilter";
import MarketsList from "../../components/marketsList";

export default function gameMarketsTemplate () {
    let { game, marketsGroupsNames, selectorKey } = this.props;
    let { marketsFilter } = this.state;
    return <div>
        <MarketsFilter game={game} marketsFilter={marketsFilter}
                       marketsGroupsNames={marketsGroupsNames}
                       setMarketsFilter={this.setMarketsFilter}/>
        <MarketsList selectorKey={selectorKey}
                     key={marketsFilter}
                     gameType={this.props.gameType}
                     marketsFilter={marketsFilter}/>
    </div>;
}